jQuery(document).ready(function ($) {
    // Open Menu
    $('.toggle-menu button').on('click', function (e) {

        e.preventDefault();

        $('.site-nav-mobile').addClass('show');
        $('body').addClass('scroll-hidden');
    });

    // Close Menu
    $('.btn-close-menu').on('click', function (e) {

        e.preventDefault();

        $('.site-nav-mobile').removeClass('show');
        $('body').removeClass('scroll-hidden');
    });
});